import type { DentistLocation } from './components/LocationSelectorModal';

export const getDentistHomeLocationSelectionAction = (
  location: DentistLocation,
  selectedDate: Date | null,
  jobsPerLocationCount: Record<number, number>,
) => {
  if (selectedDate && (jobsPerLocationCount[location.id] || 0) >= 20) {
    return {
      action: 'blocked',
      message: 'Maximum Reached: Our system allows a maximum of 20 shifts per location for this date.',
    } as const;
  }
  if (location.deactivated) {
    return {
      action: 'blocked',
      message: 'Shift Posting Disabled for this location. Please contact support.',
    } as const;
  }
  if (!location.isUpdated) {
    return { action: 'confirmOfficeInfo' } as const;
  }
  return { action: 'postShift' } as const;
};
